import BaseService from "../base.service";

const API_URL = process.env.VUE_APP_API_URL;

class HistoryService extends BaseService {
  async getHistory(payload) {
    try {
      const res = await this.post(`${API_URL}/api/transaction/histories`, payload);
      return res.data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }
}

export default new HistoryService();
